module.exports = __webpack_public_path__ + "img/pgd_a_10001.28815fa0.png";